import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserType } from "../api/authApiData";
import { removeToken } from "@/helpers/cookiesHelper";

interface AuthState {
  user: UserType | null;
  isWalletConnected: boolean;
  walletAddress: string | null;
  subscriptionStatus: string | null;
  subscriptionLoading: boolean;
}

const initialState: AuthState = {
  user: null,
  isWalletConnected: false,
  walletAddress: null,
  subscriptionStatus: null,
  subscriptionLoading: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthData: (state, action: PayloadAction<{ user: UserType }>) => {
      state.user = action.payload.user;
    },
    connectWallet: (state, action: PayloadAction<{ address: string }>) => {
      state.isWalletConnected = true;
      state.walletAddress = action.payload.address;
    },
    disconnectWallet: (state) => {
      state.isWalletConnected = false;
      state.walletAddress = null;
    },
    logout: (state) => {
      state.user = null;
      state.isWalletConnected = false;
      state.walletAddress = null;
      state.subscriptionStatus = null;
      removeToken();
      localStorage.removeItem("user");
    },
    setSubscriptionStatus: (state, action: PayloadAction<string>) => {
      state.subscriptionStatus = action.payload;
    },
    setSubscriptionLoading: (state, action: PayloadAction<boolean>) => {
      state.subscriptionLoading = action.payload;
    },
  },
});

export const {
  setAuthData,
  connectWallet,
  disconnectWallet,
  logout,
  setSubscriptionStatus,
  setSubscriptionLoading,
} = authSlice.actions;

export default authSlice.reducer;
